"use client";
import React from "react";
import Table from "@/components/primitives/table";
import { ColumnDef } from "@tanstack/react-table";
import { formatNumber } from "@/utils";
import { forceValue } from "common";

export interface Stat {
  label: string;
  value: number | string;
}
export default function TeamStatTable({ data }: { data: Option[] }) {
  const columns: ColumnDef<Option>[] = React.useMemo(
    () => [
      {
        header: "category",
        accessorKey: "label",
        enableSorting: false,
      },
      {
        header: (info) => {
          return <div className="flex w-full justify-end">Result</div>;
        },
        accessorKey: "value",
        size: 80,
        enableSorting: false,
        cell: (info) => {
          const row = info.row.original;
          return (
            <div className="flex flex-row w-full pr-1 items-center justify-end py-1 uppercase">
              {forceValue(typeof row.value === "number"
                ? formatNumber(row.value)
                : row.value)}
            </div>
          );
        },
      },
    ],
    []
  );
  return <Table columns={columns} data={data} type="banded" />;
}
